/* Native links/details remain usable when JavaScript is unavailable. */
(()=>{
 if(window.__booksChapterSidebar)return;
 window.__booksChapterSidebar=true;
 const desktop=matchMedia('(min-width:1000px)'),seen=new WeakSet();
 let scheduled=false;
 function fit(){
  scheduled=false;
  if(!desktop.matches)return;
  for(const nav of document.querySelectorAll('.chapter-jump')){
   const top=Math.max(24,Math.ceil(nav.getBoundingClientRect().top));
   nav.style.setProperty('--chapter-sidebar-top',top+'px');
  }
 }
 function scheduleFit(){if(!scheduled){scheduled=true;requestAnimationFrame(fit);}}
 function prepare(reset=false){
  for(const nav of document.querySelectorAll('.chapter-jump')){
   if(!reset&&seen.has(nav))continue;
   seen.add(nav);
   const all=nav.querySelector(':scope > .chapter-jump-all');
   if(all)all.open=desktop.matches;
  }
  scheduleFit();
 }
 function start(){prepare();new MutationObserver(()=>prepare()).observe(document.body,{childList:true,subtree:true});}
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',start,{once:true});else start();
 desktop.addEventListener('change',()=>prepare(true));
 addEventListener('scroll',scheduleFit,{passive:true});
 addEventListener('resize',scheduleFit,{passive:true});
 document.fonts?.ready.then(scheduleFit);
})();
